(function () {
    'use strict';
    /*
     * Copyright (c) 2014-15 In Hand Health.
     * All rights reserved.
     */

    // adapted from http://www.marushkevych.com/2014/05/21/angular-focus-on-input/
    angular
        .module('ihh-common-web')
        .directive('ihhFocus', ihhFocus);

    ihhFocus.$inject = ['$timeout'];

    function ihhFocus($timeout) {
        return {
            scope: {
                ihhFocus: '@'
            },
            link: function(scope, element) {
                function doFocus() {
                    $timeout(function() {
                        if (element.is(':visible')) {
                            element[0].focus();
                        }
                    }, 50); // the timeout is for the modals
                }

                if (scope.ihhFocus !== null) {
                    // focus unless attribute evaluates to 'false'
                    if (scope.ihhFocus !== 'false') {
                        doFocus();
                    }

                    // focus if attribute value changes to 'true'
                    scope.$watch('ihhFocus', function(value) {
                        if (value === 'true') {
                            doFocus();
                        }
                    });
                }
                else {
                    // if attribute value is not provided - always focus
                    doFocus();
                }
            }
        };
    }
})();